import { action } from 'typesafe-actions';

import { OutreachResponse } from 'client/ducks/outreach/service';

import * as types from './types';

export const fetchOutreachPage = () => action(types.FETCH_OUTREACH_PAGE);
export const fetchOutreachPageSuccess = (data: OutreachResponse) => action(types.FETCH_OUTREACH_PAGE_SUCCESS, data);
export const fetchOutreachPageError = (error: OutreachResponse) => action(types.FETCH_OUTREACH_PAGE_ERROR, error);
